<template>
  <div class="d-flex flex-column flex-grow-1 max100h overflow-hidden">
    <b-container class="flex-grow-1 d-flex flex-column max100h" fluid>
      <div class="d-flex flex-grow-1 max100h overflow-hidden">
        <b-card
          no-body
          class="flex-column flex-grow-1 grid  headGrid overflow-hidden"
          v-bind:class="{
            mainGridLeftEnabled:selected === 'radioLeft',
            mainGrid:selected === 'radioBoth',
            mainGridRightEnabled:selected === 'radioRight'}">
          <b-card
            no-body
            class="flex-grow-1"
            header-class="py-2">
            <div
              slot="header"
              class="">
              <h5 class="d-flex justify-content-between mb-0">
                <span>Заказ</span>
                <b-badge v-if="currentTask[0]"
                         v-bind:class="{stub: currentTaskID[0] === null}">#{{ currentTask[0].order.idDay }}
                </b-badge>
              </h5>
            </div>
            <b-card class="flex-grow-1 overflow-y-scroll">
              <cook-order-details :order="orderLeft" :brand="orderLeftBrand"></cook-order-details>
              <h5 class="m-3 stubLeft" v-bind:class="{stub: isStubLeft , nonStub: !isStubLeft}">Заказ не выбран</h5>
            </b-card>
          </b-card>

          <b-card no-body>
            <b-card
              no-body
              class="d-flex flex-column border-0 justify-content-between m-1"
            >
              <div no-body class="d-flex">
                <motivate-workshop-card v-for="workshop in workshops" :key="workshop.id" :workshop=workshop />
              </div>
              <monitor-target-progressbar
                :info-stats="motivateMonitor"
              />
            </b-card>

            <b-card no-body class="grid grid-3 flex-grow-1 overflow-y-scroll p-2">
              <b-card v-for="CookOrder in paginatedData"
                      :key="CookOrder.id"
                      @click="selectTask(CookOrder)"
                      class="cook-orders_order-card"
                      v-bind:class="{ active: currentTaskID[0] === CookOrder.id ,
                              active2: currentTaskID[1] === CookOrder.id &&
                              currentTaskID[1]!==currentTaskID[0]}">
                <div class="badges mb-2">
                  <b-badge v-if="CookOrder.order.priority !== 0" variant="danger" class="badge mr-1">
                    <icon name="exclamation"></icon>
                    Срочно
                  </b-badge>
                  <b-badge v-if="CookOrder.order.typeDelivery.keyword === TYPE_DELIVERY.PICKUP" variant="warning"
                          class="badge">
                    <icon name="truck-pickup"></icon>
                    Самовывоз
                  </b-badge>
                  <b-badge v-if="CookOrder.order.forTime !== null" class="badge">
                    <icon class="mr-2" name="clock"></icon>
                    На время: {{ CookOrder.order.forTime }}
                  </b-badge>
                </div>
                <h4>Заказ #{{ CookOrder.order.idDay }}</h4>
                <h6>Кол-во продуктов: {{ countProducts(CookOrder) }}</h6>
                <h6>Дата: {{ CookOrder.time }}</h6>
                <div v-if="CookOrder.order.comment" class="cook-orders_order-card_comment">
                  Комментарий: <br>{{ CookOrder.order.comment }}</div>
                <span v-if="CookOrder.order.kitchenComment" class="comment">{{ CookOrder.order.kitchenComment }}</span>
              </b-card>
              <b-card no-body class="stubCenter insideGrid row-not-stats-grid" v-bind:class="{stub: tasks.length !== 0}">
                <h5>Очередь заказов пуста</h5>
              </b-card>
            </b-card>
          </b-card>

          <b-card no-body class="flex-grow-1 overflow-hidden" header-class="py-2">
            <div slot="header" class="">
              <h5 class="d-flex justify-content-between mb-0"><span>Заказ</span>
                <b-badge v-if="currentTask[1]"
                         v-bind:class="{stub: currentTaskID[1] === null}">#{{ currentTask[1].order.idDay }}
                </b-badge>
              </h5>
            </div>
            <b-card class="flex-grow-1 overflow-y-scroll">
              <cook-order-details :order="orderRight" :brand="orderRightBrand"></cook-order-details>
              <h5 class="m-3 stubRight" v-bind:class="{stub: isStubRight , nonStub: !isStubRight}">Заказ не выбран</h5>
            </b-card>
          </b-card>
        </b-card>
      </div>
      <div no-body class="grid footPad"
           v-bind:class="{mainGridLeftEnabled:selected === 'radioLeft',
                        mainGrid:selected === 'radioBoth',
                        mainGridRightEnabled:selected === 'radioRight'}">
        <div>
          <b-col md="12" v-bind:class="{stub:selected === 'radioRight'}">
            <b-row class="btnControl">
              <b-btn class="col-md-6" variant="danger"
                     :disabled="currentTaskID[0]===null"
                     @click="cancelSelectedOrder(0)">Отмена
              </b-btn>
              <b-btn class="col-md-6" variant="success"
                     :disabled="currentTaskID[0]===null"
                     @click="readyOrderMutate(0)">Готово
              </b-btn>
            </b-row>
          </b-col>
        </div>
        <div no-body class="grid grid-3">
          <b-btn class="pageInfo" variant="dark"
                 :disabled="pageNumber === 0"
                 @click="prevPage">Предыдущая страница
          </b-btn>
          <div class="pageInfo">
            <p>Страница {{ pageNumber + 1 }} из ({{ pageCount }})</p>
          </div>
          <b-btn class="pageInfo" variant="dark"
                 :disabled="pageNumber >= pageCount - 1"
                 @click="nextPage">Следующая страница
          </b-btn>
        </div>
        <div>
          <b-col md="12" v-bind:class="{stub:selected === 'radioLeft'}">
            <b-row class="btnControl">
              <b-btn class="col-md-6" variant="danger"
                     :disabled="currentTaskID[1]===null"
                     @click="cancelSelectedOrder(1)">Отмена
              </b-btn>
              <b-btn class="col-md-6" variant="success"
                     :disabled="currentTaskID[1]===null"
                     @click="readyOrderMutate(1)">Готово
              </b-btn>
            </b-row>
          </b-col>
        </div>
      </div>
      <b-row>
        <b-card no-body class="col-md-12 nullPad" header-class="py-0 pr-0">
          <div slot="header" class="d-flex justify-content-between">
            <b class="countBottom">Кол-во заказов в очереди: {{ tasks.length }}</b>
            <b-btn v-b-modal.modal-center class="btnControl" variant="dark"
            >Управление окнами
            </b-btn>
          </div>
          <b-modal id="modal-center" ok-only centered title="Управление окнами">
            <h5>Включить:</h5>
            <b-form-radio-group id="btnRadio"
                                buttons v-model="selected"
                                :options="optionsVisibleScreens" name="radioBtnStacked"
                                @change="clearSelectedOrders(true)"/>
          </b-modal>

        </b-card>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import commonVar from '@/tempVariables/commonVars'
import {
  ORDERS_COLD_COOKER,
  ORDERS_COLD_CUTTER,
  ORDERS_HOT_COOKER,
  WORKSHOP_CHANGE_STAGE,
  TASKS_PIZZA_COLLECTOR,
  PRINT_TASK
} from '@/constants/graphql'

import workshopsQueries from '../graphql/workshops'
import {
  STATUS_TASK_WORKSHOP,
  TYPE_DELIVERY
} from '@/constants/keywords'
import {
  USER_ROLE_COLD_COOKER,
  USER_ROLE_COLD_CUTTER,
  USER_ROLE_HOT_COOKER,
  USER_ROLE_PIZZA_COLLECTOR
} from '@/constants/roles'
import CookOrderDetails from './CookOrderDetails'
import {USER_ROLE_PIZZA_COOKER} from '../constants/roles'
import {TASKS_PIZZA_COOKER} from '../constants/graphql'
import MonitorTargetProgressbar from './containers/workshops/MonitorTargetProgressbar'
import MotivateWorkshopCard from './MotivateWorkshopCard'
import {motivateMonitorWorkshopVars as monitorVars, workshopsVars} from '../constants/vuexVariables'
import {workshopsACT} from '../constants/vuexActions'

const selectedConst = {
  LEFT: 0,
  RIGHT: 1
}
export default {
  name: 'CookOrders',
  components: {MonitorTargetProgressbar, CookOrderDetails, MotivateWorkshopCard},
  data: function () {
    return {
      TYPE_DELIVERY,
      intervalUpdate: null,
      pageNumber: 0,
      currentTaskID: [null, null],
      currentTask: [null, null],
      orderLeft: [],
      orderLeftBrand: null,
      orderRight: [],
      orderRightBrand: null,
      cookerLeft: false,
      CookerRight: false,
      isStubLeft: false,
      isStubRight: false,
      isStubCenter: false,
      statusLeft: 'not_enabled',
      statusRight: 'not_enabled',
      selected: 'radioBoth',
      opsScroll: commonVar.opsPerfectScroll,
      userRole: null,
      initedState: false,
      intervalInit: null,
      stageQueue: null,
      stageWorking: null,
      stageFinished: null,
      testDescription: [
        {text: 'Нори', value: '0.5'},
        {text: 'Рис', value: '140'}
      ],
      optionsVisibleScreens: [
        {text: 'Оба окна', value: 'radioBoth'},
        {text: 'Левое окно', value: 'radioLeft'},
        {text: 'Правое окно', value: 'radioRight'}
      ],
      stageTaskWorkshop: STATUS_TASK_WORKSHOP,
      // data: [],
      // cookOrders: [
      //   {
      //     numOrder: 1,
      //     productName: 'Пицца Орегано'
      //   },
      //   {
      //     numOrder: 2,
      //     productName: 'Пицца Орегано'
      //   }
      // ]
      // cookOrders: createFakeProduct()
      cookOrders: [],
      cookOr: []
    }
  },
  apollo: {
    // allClients: {
    //   query: ALL_CLIENTS_BY_BRAND,
    //   update (data) {
    //     let map = new Map()
    //     data.allBrands.nodes.forEach(el => {
    //       map.set(el.id, el.clients.nodes)
    //     })
    //     return map
    //   }
    // },
    cookOrders: {
      query () {
        if (this.$userControl.jwtParsed.role === USER_ROLE_COLD_COOKER) {
          return ORDERS_COLD_COOKER
        }
        if (this.$userControl.jwtParsed.role === USER_ROLE_COLD_CUTTER) {
          return ORDERS_COLD_CUTTER
        }
        if (this.$userControl.jwtParsed.role === USER_ROLE_HOT_COOKER) {
          return ORDERS_HOT_COOKER
        }
        if (this.$userControl.jwtParsed.role === USER_ROLE_PIZZA_COLLECTOR) {
          return TASKS_PIZZA_COLLECTOR
        }
        if (this.$userControl.jwtParsed.role === USER_ROLE_PIZZA_COOKER) {
          return workshopsQueries.ORDERS_PIZZA_COOKER
        }
      },
      pollInterval: 10000,
      fetchPolicy: 'network-only',
      update (data) {
        if (this.$userControl.jwtParsed.role === USER_ROLE_COLD_COOKER) {
          if (data.tasksColdCooker) {
            if (data.tasksColdCooker.nodes.length !== this.cookOrders.length) {
              let audio = new Audio(require('../sounds/sound_cold.wav')) // path to file
              audio.play()
            }
            return data.tasksColdCooker.nodes
          } else {
            return []
          }
        }
        if (this.$userControl.jwtParsed.role === USER_ROLE_COLD_CUTTER) {
          if (data.tasksColdCutter) {
            if (data.tasksColdCutter.nodes.length !== this.cookOrders.length) {
              let audio = new Audio(require('../sounds/sound_cold.wav')) // path to file
              audio.play()
            }
            return data.tasksColdCutter.nodes
          } else {
            return []
          }
        }
        if (this.$userControl.jwtParsed.role === USER_ROLE_HOT_COOKER) {
          if (data.tasksHotCooker) {
            if (data.tasksHotCooker.nodes.length !== this.cookOrders.length) {
              let audio = new Audio(require('../sounds/sound_hot.wav')) // path to file
              audio.play()
            }
            return data.tasksHotCooker.nodes
          } else {
            return []
          }
        }
        if (this.$userControl.jwtParsed.role === USER_ROLE_PIZZA_COLLECTOR) {
          if (data.tasksPizzaCollector) {
            if (data.tasksPizzaCollector.nodes.length !== this.cookOrders.length) {
              let audio = new Audio(require('../sounds/sound_pizza.wav')) // path to file
              audio.play()
            }
            return data.tasksPizzaCollector.nodes
          } else {
            return []
          }
        }
        if (this.$userControl.jwtParsed.role === USER_ROLE_PIZZA_COOKER) {
          if (data.tasksPizzaCookerOrders) {
            if (data.tasksPizzaCookerOrders.nodes.length !== this.cookOrders.length) {
              let audio = new Audio(require('../sounds/sound_pizza.wav')) // path to file
              audio.play()
            }
            return data.tasksPizzaCookerOrders.nodes
          } else {
            return []
          }
        }
      }
    }
  },
  props: {
    size: {
      type: Number,
      required: false,
      default: 6
    }
  },
  created () {
    this.dispatch('workshops', workshopsACT.REQUEST_WORKSHOPS)
    this.userRole = this.$userControl.jwtParsed.role
    //    console.log('create')
    //    console.log(this.userRole)
    if (this.userRole === USER_ROLE_COLD_COOKER) {
      this.stageQueue = STATUS_TASK_WORKSHOP.COLD.WAITING
      this.stageWorking = STATUS_TASK_WORKSHOP.COLD.KNURLING
      this.stageFinished = STATUS_TASK_WORKSHOP.COLD.KNURLED
    }
    if (this.userRole === USER_ROLE_COLD_CUTTER) {
      this.stageQueue = STATUS_TASK_WORKSHOP.COLD.KNURLED
      this.stageWorking = STATUS_TASK_WORKSHOP.COLD.CUTTING
      this.stageFinished = STATUS_TASK_WORKSHOP.COLD.COOKED
    }
    if (this.userRole === USER_ROLE_HOT_COOKER) {
      this.stageQueue = STATUS_TASK_WORKSHOP.HOT.WAITING
      this.stageWorking = STATUS_TASK_WORKSHOP.HOT.COOKING
      this.stageFinished = STATUS_TASK_WORKSHOP.HOT.COOKED
    }
    if (this.userRole === USER_ROLE_PIZZA_COOKER) {
      this.stageQueue = STATUS_TASK_WORKSHOP.PIZZA.WAITING
      this.stageWorking = STATUS_TASK_WORKSHOP.PIZZA.FILLING
      this.stageFinished = STATUS_TASK_WORKSHOP.PIZZA.BAKING
    }
    if (this.userRole === USER_ROLE_PIZZA_COLLECTOR) {
      this.stageQueue = STATUS_TASK_WORKSHOP.PIZZA.BAKING
      this.stageWorking = null
      this.stageFinished = STATUS_TASK_WORKSHOP.PIZZA.COOKED
    }
    setTimeout(() => {
      document.location.reload(true)
    }, 30 * 60 * 1000)
  },
  mounted () {
    //    console.log('WTF')
    setTimeout(() => {
      this.timeUpdate()
    }, 500)
    this.intervalInit = setInterval(() => {
      this.refreshCurrent()
    }, 1000)
    this.intervalUpdate = setInterval(() => {
      this.timeUpdate()
    }, 5000)
  },
  beforeDestroy () {
    clearInterval(this.intervalUpdate)
  },
  watch: {
    cookOrders () {
      this.timeUpdate()
      this.checkExistSelected()
    }
  },
  methods: {
    getter (namespace, getter) {
      return this.$store.getters[`${namespace}/${getter}`]
    },
    dispatch (namespace, action) {
      this.$store.dispatch(`${namespace}/${action}`)
    },
    stateVar (namespace, variable) {
      return this.$store.state[namespace[variable]]
    },
    commit (namespace, query, payload) {
      this.$store.commit(`${namespace}/${query}`, payload)
    },
    refreshCurrent () {
      if (!this.initedState) {
        if (this.tasks.length !== 0) {
          let i
          for (i = 0; i < this.tasks.length; i++) {
            if (this.tasks[i].stageWorkshop === this.stageWorking) {
              if (this.currentTask[0] === null) {
                this.setLeftOrder(this.tasks[i])
              } else if (this.currentTask[1] === null) {
                this.setRightOrder(this.tasks[i])
              }
            }
          }
          this.initedState = true
        }
      } else {
        clearInterval(this.intervalInit)
      }
    },
    checkExistSelected () {
      let selectedExists = [false, false]
      this.cookOrders.forEach(task => {
        selectedExists[selectedConst.LEFT] |= (task.id === this.currentTaskID[selectedConst.LEFT])
        selectedExists[selectedConst.RIGHT] |= (task.id === this.currentTaskID[selectedConst.RIGHT])
      })
      Object.keys(selectedConst).forEach(key => {
        let val = selectedConst[key]
        if (this.currentTaskID[val] !== null && selectedExists[val] === false) {
          this.clearSelectedOrders(val)
        }
      })
    },
    timeUpdate () {
      this.cookOrders.forEach(task => {
        let time = this.waitingTime(task.timeCreation)
        this.$set(task, 'time', time)
      })
      // setTimeout(() => { this.timeUpdate() }, 5000)
    },
    async selectTask (task) {
      // change status of previous selected item
      let numCooker = null
      if (this.selected === 'radioBoth') {
        if (this.currentTask[0] !== null && this.currentTask[1] !== null && this.currentTask[1].id !== task.id) {
          numCooker = 1
        }
      } else if (this.selected === 'radioLeft') {
        if (this.currentTask[0] !== null && this.currentTask[0].id !== task.id) {
          numCooker = 0
        }
      } else if (this.selected === 'radioRight') {
        if (this.currentTask[1] !== null && this.currentTask[1].id !== task.id) {
          numCooker = 1
        }
      }
      if (numCooker !== null) {
        this.$apollo.mutate({
          mutation: WORKSHOP_CHANGE_STAGE,
          variables: {
            id: this.currentTask[numCooker].id,
            taskWorkshopPatch: {stageWorkshop: this.stageQueue}
          }
        })
      }
      if (this.stageWorking !== null) {
        await this.$apollo.mutate({
          mutation: WORKSHOP_CHANGE_STAGE,
          variables: {
            id: task.id,
            taskWorkshopPatch: {stageWorkshop: this.stageWorking}
          }
        })
      }
      if (this.selected === 'radioBoth') {
        // left order is empty and right order not equal to selecting order
        if (this.currentTaskID[0] === null && this.currentTaskID[1] !== task.id) {
          this.setLeftOrder(task)
        } else if (this.currentTaskID[0] !== task.id) {
          this.setRightOrder(task)
        }
      } else if (this.selected === 'radioLeft') {
        this.setLeftOrder(task)
      } else if (this.selected === 'radioRight') {
        this.setRightOrder(task)
      }
    },
    setLeftOrder (task) {
      this.currentTaskID[0] = task.id
      this.currentTask[0] = task
      this.orderLeftBrand = task.order.brandName
      if (this.userRole === USER_ROLE_COLD_COOKER || this.userRole === USER_ROLE_COLD_CUTTER) {
        this.orderLeft = task.order.coldProducts.nodes
      }
      if (this.userRole === USER_ROLE_HOT_COOKER) {
        this.orderLeft = task.order.hotProducts.nodes
      }
      if (this.userRole === USER_ROLE_PIZZA_COLLECTOR || this.userRole === USER_ROLE_PIZZA_COOKER) {
        this.orderLeft = task.order.pizzaProducts.nodes
      }
      this.isStubLeft = true
    },
    setRightOrder (task) {
      this.currentTaskID[1] = task.id
      this.currentTask[1] = task
      this.orderRightBrand = task.order.brandName
      if (this.userRole === USER_ROLE_COLD_COOKER || this.userRole === USER_ROLE_COLD_CUTTER) {
        this.orderRight = task.order.coldProducts.nodes
      }
      if (this.userRole === USER_ROLE_HOT_COOKER) {
        this.orderRight = task.order.hotProducts.nodes
      }
      if (this.userRole === USER_ROLE_PIZZA_COLLECTOR || this.userRole === USER_ROLE_PIZZA_COOKER) {
        this.orderRight = task.order.pizzaProducts.nodes
      }
      this.isStubRight = true
    },
    readyOrderMutate (numCooker) {
      let numOrder = this.currentTaskID[numCooker]
      this.$apollo.mutate({
        mutation: WORKSHOP_CHANGE_STAGE,
        variables: {
          id: numOrder,
          taskWorkshopPatch: {stageWorkshop: this.stageFinished}
        }
      })
        .then(() => {
          // if (this.stageFinished === STATUS_TASK_WORKSHOP.PIZZA.COOKED) {
          //   this.$apollo.mutate({
          //     mutation: PRINT_TASK,
          //     variables: {
          //       idTask: numOrder
          //     }
          //   })
          // }
          if (numCooker === 0) {
            this.cookOrders.splice(this.cookOrders.findIndex((el) => el.id === this.currentTaskID[0]), 1)
            this.isStubLeft = false
          } else {
            this.cookOrders.splice(this.cookOrders.findIndex((el) => el.id === this.currentTaskID[1]), 1)
            this.isStubRight = false
          }

          this.currentTaskID[numCooker] = null
          this.currentTask[numCooker] = null
          if (numCooker === 0) {
            this.orderLeft = []
          } else {
            this.orderRight = []
          }
        })
    },
    clearSelectedOrders (force = false) {
      // console.log('ff')
      if (force) {
        for (let i = 0; i < 2; i++) {
          if (this.currentTask[i] !== null) {
            this.$apollo.mutate({
              mutation: WORKSHOP_CHANGE_STAGE,
              variables: {
                id: this.currentTask[i].id,
                taskWorkshopPatch: {stageWorkshop: this.stageQueue}
              }
            })
          }
        }
      }
      this.currentTaskID[0] = null
      this.currentTaskID[1] = null
      this.orderRight = null
      this.orderLeft = null
      this.isStubLeft = false
      this.isStubRight = false
      // this.currentTask[0] = null
      // this.currentTask[1] = null
    },
    cancelSelectedOrder (numOrder) {
      this.$apollo.mutate({
        mutation: WORKSHOP_CHANGE_STAGE,
        variables: {
          id: this.currentTaskID[numOrder],
          taskWorkshopPatch: {stageWorkshop: this.stageQueue}
        }
      })
        .then(() => {
          this.currentTaskID[numOrder] = null
          this.currentTask[numOrder] = null
          if (numOrder === 0) {
            this.orderLeft = []
            this.isStubLeft = false
          } else {
            this.orderRight = []
            this.isStubRight = false
          }
        })
    },
    nextPage () {
      this.pageNumber++
    },
    prevPage () {
      this.pageNumber--
    },
    countProducts (order) {
      let counts = 0
      if (this.userRole === USER_ROLE_COLD_COOKER || this.userRole === USER_ROLE_COLD_CUTTER) {
        order.order.coldProducts.nodes.forEach(function (count) {
          counts += count.count
        })
      }
      if (this.userRole === USER_ROLE_HOT_COOKER) {
        order.order.hotProducts.nodes.forEach(function (count) {
          counts += count.count
        })
      }
      if (this.userRole === USER_ROLE_PIZZA_COLLECTOR || this.userRole === USER_ROLE_PIZZA_COOKER) {
        order.order.pizzaProducts.nodes.forEach(function (count) {
          counts += count.count
        })
      }
      return counts
    },
    waitingTime (time) {
      let timeInWait = this.$moment(time).fromNow()
      // timeInWait = order.timeCreation
      return timeInWait
    }
  },
  computed: {
    workshops () {
      return this.getter('workshops', workshopsVars.WORKSHOPS)
    },
    motivateMonitor () {
      return this.$store.state.workshops.motivateMonitor[monitorVars.cookingTargetCurrentStats]
    },
    pageCount () {
      let l = this.tasks.length
      let s = this.size
      return Math.max(Math.ceil(l / s), 1)
    },
    paginatedData () {
      const start = this.pageNumber * this.size
      const end = start + this.size
      return this.tasks
        .slice(start, end)
    },
    tasks () {
      return this.cookOrders.filter((task) => {
        return task.stageWorkshop !== this.stageFinished
      })
    }
  }
}

</script>

<style lang="scss" scoped>
.order {
  cursor: pointer;

  &:hover {
    background: #DBEAB4;
  }

  &.activeIt {
    background: #eeffc4;
  }
}
.products {
  padding-left: 15px;
  padding-right: 15px;
}
.max100h {
  max-height: 100%;
}
.nullPad {
  padding-left: 0;
  padding-right: 0;
}
#collapseOrders {
  border-bottom: 1px solid #DFDFDF;
}
.pageInfo {
  height: 40px;
}
.pageInfo p {
  text-align: center;
  line-height: 40px;
  /*vertical-align: center;*/
}
.grid {
  display: grid;
}
.lll {

}
.mainGrid {
  grid-template-columns: 1fr 3fr 1fr;
  grid-template-rows: 100%;
  /*> .card:nth-child(3n + 1) {*/
  /*border-left: 1px solid rgba(0, 0, 0, 0.125);;*/
  /*}*/
}
.mainGridLeftEnabled {
  grid-template-columns: 1fr 3fr 0fr;
  /*> .card:nth-child(3n + 1) {*/
  /*border-left: 1px solid rgba(0, 0, 0, 0.125);;*/
  /*}*/
}
.mainGridRightEnabled {
  grid-template-columns: 0fr 3fr 1fr;
  /*> .card:nth-child(3n + 1) {*/
  /*border-left: 1px solid rgba(0, 0, 0, 0.125);;*/
  /*}*/
}
.row-not-stats-grid {
  grid-column: 1 /4;
  grid-row: 2/4;
}
.grid-3 {
  grid-template-columns:  repeat(3, 1fr);
  grid-template-rows: 1fr 1fr;
  gap: 10px,
}

.grid-height {
  /*height: min(vh);*/
}

/*.card-header{*/
/*grid-column-start: 1;*/
/*grid-column-end: 4;*/
/*}*/
.footPad {
  margin-bottom: 20px;
}

.active {
  background-color: #efb74a;
}

.active2 {
  background-color: #ff705a;
}

.btnControl {
  height: 40px;
}

.liProducts {
  font-size: 20px;
}

.nav-scroller {
  overflow-y: scroll;
}

.bold {
  font-weight: bold;
}

.stub {
  display: none !important;
}

.nonStub {
  display: block !important;
}

.stubCenter {
  display: flex;
  justify-content: center;
  align-content: space-between;
  align-items: center;
  flex-direction: column;
}

.stubCenter h5 {
  opacity: 0.8;
}

.stubLeft {
  display: flex;
  justify-content: center;
  align-content: space-between;
  align-items: center;
  flex-direction: column;
  opacity: 0.8;
}

.stubRight {
  display: flex;
  justify-content: center;
  align-content: space-between;
  align-items: center;
  flex-direction: column;
  opacity: 0.8;
}

.countBottom {
  display: flex;
  justify-content: center;
  flex-direction: column;
}

.marginForP {
  margin-bottom: 0;
}

.comment {
  background: #c3e3ff;
  padding: 2px 10px;
  border: 1px dashed #000;
  display: inline-block;
}

.cook-orders_order-card {
  display: flex;
  flex-direction: column;

  .card-body {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    overflow-y: scroll;
  }

  .cook-orders_order-card_comment {
    flex: 1;
    // overflow: scroll;
    // overflow-y: scroll;

    -ms-overflow-style: none;  /* IE and Edge */
    scrollbar-width: none;  /* Firefox */
    &::-webkit-scrollbar {
      display: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CookOrders.vue